export default __webpack_public_path__ + "static/media/weather-favicon.5bce3243.png";